import SvgIcon, { SvgIconOwnProps } from '@mui/material/SvgIcon';

export default function FrameIcon(props: SvgIconOwnProps) {
  return (
    <SvgIcon {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.9077 0.55814C3.9077 0.249888 3.65782 0 3.34956 0C3.04131 0 2.79142 0.249888 2.79142 0.55814V2.7907H0.55814C0.249887 2.7907 1.3469e-08 3.04058 0 3.34884C-1.34825e-08 3.65709 0.249887 3.90698 0.55814 3.90698H2.79142V12.093H0.55814C0.249887 12.093 1.3469e-08 12.3429 0 12.6512C-1.34825e-08 12.9594 0.249887 13.2093 0.55814 13.2093H2.79142V15.4419C2.79142 15.7501 3.04131 16 3.34956 16C3.65782 16 3.9077 15.7501 3.9077 15.4419V13.2093L12.0938 13.2093V15.4419C12.0938 15.7501 12.3436 16 12.6519 16C12.9601 16 13.21 15.7501 13.21 15.4419V13.2093H15.4419C15.7501 13.2093 16 12.9594 16 12.6512C16 12.3429 15.7501 12.093 15.4419 12.093H13.21V3.90698H15.4419C15.7501 3.90698 16 3.65709 16 3.34884C16 3.04059 15.7501 2.7907 15.4419 2.7907H13.21V0.55814C13.21 0.249888 12.9601 0 12.6519 0C12.3436 0 12.0938 0.249888 12.0938 0.55814V2.7907L3.9077 2.7907V0.55814ZM12.0938 12.093V3.90698L3.9077 3.90698V12.093L12.0938 12.093Z"
        />
      </svg>
    </SvgIcon>
  );
}
